<template>
    <div class="insulaMaterialSet">
        <div class="title">
            λ=λ0+A1×(Tm-A0)+B1×(Tm-B0)2+C1×(Tm-C0)3
        </div>
        <div class="title">
            Tm≤Tmax
        </div>
       <el-form ref="form" label-width="110px" class="attr_common" label-position="left" :inline="true">
           <el-form-item label="保温材料名称:">
                <el-input v-model="curSuggestion.name" placeholder="输入数值" :disabled="!updateFlag"/>
            </el-form-item>
           <el-form-item label="λ0[w/(m·℃)]:">
                <el-input v-model="curSuggestion.λ0" placeholder="输入数值" :disabled="!updateFlag"/>
            </el-form-item>
            <el-form-item label="Tmax(℃):">
                <el-input v-model="curSuggestion.Tmax" placeholder="输入数值" :disabled="!updateFlag"/>
            </el-form-item>
            <el-form-item label="A1:">
                <el-input v-model="curSuggestion.A1" placeholder="输入数值" :disabled="!updateFlag"/>
            </el-form-item>
            <el-form-item label="A0:">
                <el-input v-model="curSuggestion.A0" placeholder="输入数值" :disabled="!updateFlag"/>
            </el-form-item>
            <el-form-item label="B1:">
                <el-input v-model="curSuggestion.B1" placeholder="输入数值" :disabled="!updateFlag"/>
            </el-form-item>
            <el-form-item label="B0:">
                <el-input v-model="curSuggestion.B0" placeholder="输入数值" :disabled="!updateFlag"/>
            </el-form-item>
            <el-form-item label="C1:">
                <el-input v-model="curSuggestion.C1" placeholder="输入数值" :disabled="!updateFlag"/>
            </el-form-item>
            <el-form-item label="C0:">
                <el-input v-model="curSuggestion.C0" placeholder="输入数值" :disabled="!updateFlag"/>
            </el-form-item>
            <el-form-item label="单价:">
                <el-input v-model="curSuggestion.unitPrice" placeholder="输入数值" :disabled="!updateFlag"/>
            </el-form-item>
        </el-form>
        
        <!--材料列表-->
        <el-table
            :data="suggestions"
            border
            style="width: 100%"
            class="material-table"
            max-height="300"
            highlight-current-row
            row-class-name="material-row"
            cell-class-name="material-cell"
            @current-change="suggestionCurrentChange"
            ref="suggestionsTable">

            <el-table-column
                prop="id"
                width="50"
                label="编号">
            </el-table-column>
            <el-table-column
                prop="name"
                label="材料名称">
            </el-table-column>
            <el-table-column
                prop="λ0"
                label="λ0"
                width="80">
            </el-table-column>
            <el-table-column
                prop="A1"
                label="A1"
                width="80">
            </el-table-column>
            <el-table-column
                prop="A0"
                label="A0"
                width="80">
            </el-table-column>
            <el-table-column
                prop="B1"
                label="B1"
                width="80">
            </el-table-column>
             <el-table-column
                prop="B0"
                label="B0"
                width="80">
            </el-table-column>
            <el-table-column
                prop="C1"
                label="C1"
                width="80">
            </el-table-column>
            <el-table-column
                prop="C0"
                label="C0"
                width="80">
            </el-table-column>
            <el-table-column
                prop="Tmax"
                label="Tmax"
                width="80">
            </el-table-column>
             <el-table-column
                prop="unitPrice"
                label="单价"
                width="80">
            </el-table-column>
        </el-table>

        <div class="foot-btn">
            <el-button size="medium" type="primary" @click="addMaterials" v-if="!updateFlag">新增</el-button>
            <el-button size="medium" type="primary" @click="updateMaterials" v-if="!updateFlag">修改</el-button>
            <el-button size="medium" type="primary" @click="deleteMaterials" v-if="!updateFlag&&this.suggestions.length>1">删除</el-button>
            <el-button size="medium" type="primary" @click="saveMaterials" v-if="updateFlag">保存</el-button>
            <el-button size="medium" type="primary" @click="cancelSave" v-if="updateFlag">取消</el-button>
        </div>
    </div>
</template>

<script>
import _remove from "lodash/remove";
import _find from "lodash/find";

export default {
    name:"overHeadParamSet",
     computed:{
         // 全局配置
        globalConfig(){
            return this.$store.state.simulation.globalConfig;
        },
        // 保温材料
        insulaMaterialSugs(){
            return this.$store.state.simulation.globalConfig.insulaMaterialSugs;
        }
    },
    data(){
        return {
            curSuggestion:{
                id:0,
                name:"默认材料", // 保温材料名称
                λ0:0,
                Tmax:0,
                A1:0,
                A0:0,
                B1:0,
                B0:0,
                C1:0,
                C0:0,
                unitPrice:0,
            } , // 当前属性
            suggestions:[
                {
                    id:0,
                    name:"默认材料", // 保温材料名称
                    λ0:0,
                    Tmax:0,
                    A1:0,
                    A0:0,
                    B1:0,
                    B0:0,
                    C1:0,
                    C0:0,
                    unitPrice:0
                }
            ], // 方案数组

            updateFlag:false, // 是否可以编辑
        }
    },
    mounted(){
        // 初始化数据
        this.init_data();
    },
    methods:{
        // 初始化数据
        init_data(){
            this.suggestions=JSON.parse(JSON.stringify(this.insulaMaterialSugs));
            this.curSuggestion=this.suggestions[0]||{};
        },
        // 更新材质
        updateMaterials(item){
            item=item||this.curSuggestion;
            this.updateFlag=true;
        },
        // 新增
        addMaterials(){
            let suglength=this.suggestions.length;
            this.curSuggestion={
                id:suglength,
                name:"默认材料"+suglength, // 保温材料名称
                λ0:0,
                Tmax:0,
                A1:0,
                A0:0,
                B1:0,
                B0:0,
                C1:0,
                C0:0,
                unitPrice:0,
            }
            this.updateFlag=true;
        },

        // 删除
        deleteMaterials(){
            let item=this.curSuggestion;
            if(item.id){
                this.suggestions=_remove(this.suggestions, function(it) {  return it.id!=item.id;});
            }
            // 恢复默认
            this.curSuggestion=JSON.parse(JSON.stringify(this.suggestions[0]));
            // 设置选中
            this.$refs.suggestionsTable.setCurrentRow(this.suggestions[0]);
        },

        // 保存
        saveMaterials(){
            let temp=null;
            this.suggestions.forEach((item,index)=>{
                if(item.id == this.curSuggestion.id){
                    item=JSON.parse(JSON.stringify(this.curSuggestion));
                    temp=item;
                    this.$set(this.suggestions,index,item); // 更新表格
                }
            });
            // 如果存在该类型的材料，则更新，否在新增
            if(!temp){
                temp=JSON.parse(JSON.stringify(this.curSuggestion));
                this.suggestions.push(temp);
            }
            // 关闭修改
            this.updateFlag=false;

            // 设置选中
            this.$refs.suggestionsTable.setCurrentRow(temp);

            // 触发父元素数组更新
            this.globalSuggestionChange();
            // 弹出提示框，提示保存成功
            this.$message({
                message:"保存成功",
                type:"success",
                duration:2000
            });

        },
        // 取消保存
        cancelSave(){
            let currentId=this.curSuggestion.id;
            let temp=_find(this.suggestions, function(o) { return o.id == currentId; });
            if(!temp){
                temp=this.suggestions[0];
            }
            this.curSuggestion=JSON.parse(JSON.stringify(temp));
            this.updateFlag=false;
        },
        // 选中行改变
        suggestionCurrentChange(row){
            this.curSuggestion=JSON.parse(JSON.stringify(row)); // 为了避免修改原数据
        },
        // 全局方案修改
        globalSuggestionChange(){
            let temp=JSON.parse(JSON.stringify(this.globalConfig));
            temp.insulaMaterialSugs=this.suggestions;
            this.$store.commit("simulation/setGlobalConfig",temp);
            // 后台保存用户配置
            this.$store.dispatch("simulation/saveGlobalConfig",temp);
        },

    }
}
</script>

<style lang="scss">
.setting-content.insulaMaterialSet{
    width: 840px;

    .title{
        font-size: 16px;
        margin-bottom: 10px;
    }
    .attr_common{
        display:flex;
        flex-wrap: wrap;

        .el-form-item{
            margin-right: 0;
            width: 33%;
        }
    }

    /** 表格 */
    .material-table{
        margin-bottom: 10px;

        .el-table__header th{
            text-align: center;
            background: cornflowerblue;
            color:#fff;
        }

        .el-table__body tr:first-child{
            color:#aea8a8;
        }

        .material-cell{
            text-align: center;
            padding: 6px 0;
            
            /** 保温厚度 */
            .thickness{
                width: 50%;
            }
        }

        .table-operate{
            .cell{
                padding:0;

                button{
                    padding:4px 6px;
                    margin-left:3px;
                }
            }
        }
    }
}
</style>